import "./pageloader.css";

class PageLoaderElement extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.innerHTML = `
            <span class="loader"></span>
        `;
    }
}

customElements.define("bd-pageloader", PageLoaderElement);
